const VoucherTypeSetting = {
  OneTimeClaim: "one-time",
  AutoSeed: "auto-seed",
  MultiClaimGeneric: "multi-claim",
  MultiCodeGeneric: "multi-code",
};

export default VoucherTypeSetting;
